<template>
    <div>
        <a-drawer title="数据接入" placement="right" :closable="true" :visible="logentryShow" :width="600" @close="handleClose">
            <h3 @click="handleTest">配置参数：</h3>
            <a-table :columns="columns" :data-source="data" bordered :pagination="false"  rowKey="id">
               <template slot="datavalue" slot-scope="text, record">
                    <span v-if="record.id == 1">
                        cn-shanghai.log.aliyuncs.com
                    </span>
                    <span v-if="record.id == 2">
                        {{projectname}}
                    </span>
                    <span v-if="record.id == 3">
                       {{logstorename}}
                    </span>
                </template>
            </a-table>
            <br>
            <h3>前端监控脚本:</h3>
            <a-input placeholder="" v-model="watchScript" />
            <br>
            <br>
            <h3>接入方式：</h3>
            <a-tabs default-active-key="0" @change="callback">
                <a-tab-pane key="0" tab="SDK">
                </a-tab-pane>
                <a-tab-pane key="1" tab="HTTP GET" force-render>
                </a-tab-pane>
                <a-tab-pane key="2" tab="HTML img" force-render>
                </a-tab-pane>
            </a-tabs>

            <editor ref="configvaluesource" v-model="c_code"  @init="editorInit" lang="javascript" theme="monokai" width="100%"
                        height="430" style="font-size:15px;"></editor>

                        <!-- <a-button @click="handleTest">ces</a-button> -->
        </a-drawer>
    </div>
</template>
<script>
import Editor from 'vue2-ace-editor'

const columns = [
    {
        title:'#',
        dataIndex: 'id',
        key: 'id',
        align:'center'
    },
    {
        title: '配置项',
        dataIndex: 'name',
        key: 'name',
        align:'center'

    },
    {
        title: '值',
        dataIndex: 'value',
        key: 'value',
        align:'center',
        scopedSlots:{customRender:'datavalue'},

    },
    
]

const wathcScript = '%3Cscript%20type=%22text/javascript%22%20src=%22https://032001.zhonglunnet.com/fp-web/zllife-loger.js%22%20defer=%22defer%22%3E%3C/script%3E';

const exampleCode = [
    "/**%0D%0A%20%20%20%20%E5%AE%89%E8%A3%85%E4%BE%9D%E8%B5%96%E5%8C%85%0D%0A%20%20%20%20npm%20install%20--save%20js-sls-logger%0D%0A%20*/%0D%0A%0D%0Aimport%20SlsWebLogger%20from%20'js-sls-logger'%0D%0A%0D%0Aconst%20opts%20=%20%7B%0D%0A%20%20%20%20host:%20%22$%7Bhost%7D%22,%20//%20%E6%89%80%E5%9C%A8%E5%8C%BA%E5%9F%9F%E7%9A%84host%0D%0A%20%20%20%20project:%20%22$%7Bproject%7D%22,%20//%20project%E5%90%8D%E7%A7%B0%0D%0A%20%20%20%20logstore:%20%22$%7Blogstore%7D%22,%20//%20logstore%E5%90%8D%E7%A7%B0%0D%0A%20%20%20%20time:%2010,%20//%20%E5%AE%9A%E4%B9%89%E6%97%B6%E9%97%B4%EF%BC%8C%E9%BB%98%E8%AE%A4%E6%98%AF10%E7%A7%92%EF%BC%8Cnumber%E7%B1%BB%E5%9E%8B%EF%BC%8C%E9%80%89%E5%A1%AB%0D%0A%20%20%20%20count:%2010,%20//%20%E5%AE%9A%E4%B9%89%E6%95%B0%E6%8D%AE%E6%9D%A1%E6%95%B0%EF%BC%8C%E9%BB%98%E8%AE%A4%E6%98%AF10%E6%9D%A1%EF%BC%8Cnumber%E7%B1%BB%E5%9E%8B%EF%BC%8C%E9%80%89%E5%A1%AB%0D%0A%20%20%20%20compress:%20true,%20//%20%E6%98%AF%E5%90%A6%E5%90%AF%E7%94%A8%E5%8E%8B%E7%BC%A9%EF%BC%8C%E9%BB%98%E8%AE%A4%E4%B8%BAtrue%0D%0A%7D;%0D%0A%0D%0Aconst%20logger%20=%20new%20SlsWebLogger(opts);%0D%0A%0D%0Alogger.send(%7B%0D%0A%20%20%20%20key1:%20%22val1%22,%0D%0A%20%20%20%20key2:%20%22val2%22,%0D%0A%20%20%20%20key3:%207998,%0D%0A%7D);",
    "/**%0A%20%20%20%20%E7%9B%B4%E6%8E%A5%E5%8F%91%E9%80%81get%E8%AF%B7%E6%B1%82,%E4%B8%8D%E6%94%AF%E6%8C%81%E4%B8%8A%E4%BC%A016KB%E4%BB%A5%E4%B8%8A%E7%9A%84body!!!!!%0A%20%20%20%20%E5%8F%82%E6%95%B0%E8%87%AA%E8%A1%8C%E6%8B%BC%E6%8E%A5%0A%20*/%0A%0Aconst%20url%20='http://$%7Bproject%7D.$%7Bhost%7D/logstores/$%7Blogstore%7D/track?APIVersion=0.6.0&key1=val1&key2=val2'%0A%0A$.get(url)",
    "/**%0D%0A%20%20%20%20%E9%80%9A%E8%BF%87%E5%8A%A0%E8%BD%BD%E5%9B%BE%E7%89%87%E5%8F%91%E9%80%81%E8%AF%B7%E6%B1%82,%E4%B8%8D%E6%94%AF%E6%8C%81%E4%B8%8A%E4%BC%A016KB%E4%BB%A5%E4%B8%8A%E7%9A%84body!!!!!%0D%0A%20%20%20%20%E5%8F%82%E6%95%B0%E8%87%AA%E8%A1%8C%E6%8B%BC%E6%8E%A5%0D%0A%20*/%0D%0A%0D%0Aconst%20request%20=%20(data)%20=%3E%20%7B%0D%0A%20%20%20%20const%20EnvTest%20=%20getEnv();%0D%0A%20%20%20%20let%20url%20=%20EnvTest%20===%20'pro'%20?%20'http://$%7Bproject%7D.$%7Bhost%7D/logstores/$%7Blogstore%7D/track.gif?'%20:%20'http://$%7Bproject%7D.$%7Bhost%7D/logstores/$%7Blogstore%7D/track.gif?';%0D%0A%20%20%20%20url%20+=%20'APIVersion=0.6.0';//%E5%BF%85%E8%A6%81%E5%8F%82%E6%95%B0%0D%0A%20%20%20%20url%20+=%20'&key1=v1';%0D%0A%20%20%20%20//...%0D%0A%20%20%20%20const%20img%20=%20document.createElement('img')%0D%0A%20%20%20%20img.src%20=%20url%0D%0A%20%20%20%20img.hidden%20=%20true%0D%0A%7D"
];
export default {

    data() {
        return {
            columns,
            data:[
                {
                    id:1,
                    name:'Host',
                    value:''
                },
                {
                    id:2,
                    name:'Project',
                    value:''
                },
                {
                    id:3,
                    name:'Logstore',
                    value:''
                }
            ],
            watchScript:decodeURI(wathcScript),
            c_code:decodeURI(exampleCode[0])
 
        };
    },
    props: {
        projectname: String,
        logstorename: String,
        logentryShow:Boolean
    },
    methods: {
        callback(key) {
            this.c_code = decodeURI(exampleCode[key])
        },
        handleTest(){
        },
        handleClose(){
            this.$emit('onLogEntryClose',false);
        },
        editorInit() {
            // require('brace/ext/language_tools') //language extension prerequsite...
            require('brace/mode/json')                
            require('brace/mode/javascript')    //language
            require('brace/mode/less')
            require('brace/theme/monokai')
        },
    },

    computed:{
        
    },
    components:{
        Editor
    },
    mounted(){
    }
};
</script>
<style scoped>
  
</style>

<style lang="less">

</style>